import React from "react";
import { connect, useSelector } from "react-redux";
import WizardStep from "../common/Wizard/WizardStep";
import { formatDateTimeToZone, getRoleName } from "../common/Helpers";


export function WorkflowWizard(props) {

    const contract = useSelector(state => state.contract.contract);

    // the stage list currently driving the schedule display -- passed down from WorkflowSingle
    // (contract.approval_levels while unedited, or a freshly-picked template's stages), falling
    // back to the contract's own approval_levels when no override was passed at all
    const approvalStages = props.approvalStages || contract.approval_levels || [];

    const vcaName = props.newParties.VCA && props.newParties.VCA === contract.VCA.email && contract.VCA.first_name ? contract.VCA.first_name + " " + contract.VCA.last_name : "Vendor Rep";
    const arName = props.newParties.AR && props.newParties.AR === contract.AR.email && contract.AR.first_name ? contract.AR.first_name + " " + contract.AR.last_name : "Accounts Receivable";
    const apName = props.newParties.AP && props.newParties.AP === contract.AP.email && contract.AP.first_name ? contract.AP.first_name + " " + contract.AP.last_name : "Accounts Payable";

    const payment_duration = contract.duration_payment ? "By day " + contract.duration_payment : "No deadline";
    const review_duration = contract.duration_review ? "By day " + contract.duration_review  : "No deadline";

    return (
        <div className="doc-section gap-below-m">
            <h3 className="title2 heavy label" >Schedule</h3>
            <div className={`flex-row ${props.className}`} style={{marginLeft: "8px", marginRight: "-8px"}}>
                <WizardStep
                    step="Send Invoice"
                    party_name={vcaName}
                    date="Day 0"
                    display="schedule"
                    email={props.newParties.VCA}
                />

                {approvalStages.map((stage, index) => {
                    const role = "APP" + (index + 1);
                    const isLast = index === approvalStages.length - 1;
                    const party = stage.parties && stage.parties[0];
                    const stageDisplayName = getRoleName(stage.stage_name || stage.name);
                    const partyName = party && props.newParties[role] === party.email && party.first_name
                        ? party.first_name + " " + party.last_name
                        : stageDisplayName;
                    return (
                        <WizardStep
                            key={index}
                            step={stageDisplayName}
                            party_name={partyName}
                            date={isLast ? review_duration : ""}
                            display="schedule"
                            email={props.newParties[role]}
                        />
                    );
                })}

                <WizardStep
                    step="Payment"
                    party_name={apName}
                    date={payment_duration}
                    display="schedule"
                    email={props.newParties.AP}
                />
                <WizardStep
                    step="Close Invoice"
                    party_name={arName}
                    date=""
                    display="schedule"
                    email={props.newParties.AR}
                />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(WorkflowWizard);

